import { Component, OnInit } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { UserSessionService } from '../../UserSession/user-session.service';
import { CustomformsService } from '../../apiclient';
import {Location} from '@angular/common';
import { CustomformsActionsCellComponent } from './customforms.actions.cell.component';

/**
 * Componente que renderiza el listado de customforms
 */
@Component({
  selector: 'ngx-customforms',
  templateUrl: './customforms.component.html',
  styleUrls: ['./customforms.component.scss']
})
export class CustomformsComponent implements OnInit {

  settings = {
    actions: {
      delete: false,
      add: false,
      edit:false,
      position: 'right'
  },
    /*
    add: {
      addButtonContent: '<i class="nb-plus"></i>',
      createButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    },
    */
    columns: {
      id: {
        title: 'ID',
        type: 'number',
      },
      company_name: {
        title: 'Compañía',
        type: 'string',
      },
      module_name: {
        title: 'Módulo',
        type: 'string',
      },
      form_name: {
        title: 'Formulario',
        type: 'string',
      },
      acciones: {
        title: '',
        type: 'custom',
        renderComponent: CustomformsActionsCellComponent,
        filter : false,
      }
    },
  };

  source: LocalDataSource = new LocalDataSource();

  constructor(private userSessionService: UserSessionService,
    private companyService: CustomformsService, private location: Location) { }

    /**
     * @ignore
     */
  ngOnInit(): void {
      this.companyService.customformslist(this.userSessionService.accessToken).subscribe((data) => {
        this.source.load(data);
      });
  }

  /**
   * Vuelve a la página anterior
   */
  back(): void{
    this.location.back()
  }
}
